import clsx from "clsx";
import React from "react";
import { Link, Outlet, useLocation } from "react-router-dom";

import { Label } from "@fronterahealth/frontera-ui-components";

const ehrDataTabs = [
  { path: "programming", name: "Programming (view only)" },
  { path: "sync-history", name: "Sync History" },
] as const;

// Internal-only view of what we hold from the client's EHR: its sub-tabs run down the
// left of the page content. Each tab fetches its own data.
export const ClientEhrData: React.FC = () => {
  const { pathname, state } = useLocation();
  // clients/:clientId/ehr-data/<tab>/... (programming has its own goal/target segments).
  const segments = pathname.split("/").filter(Boolean);
  const currentTab = segments[segments.indexOf("ehr-data") + 1];

  return (
    // ph-no-capture: everything here is stored EHR data (PHI), so mask it in session replays.
    <div className="flex w-full items-start gap-4 p-4 ph-no-capture">
      <nav aria-label="EHR data sections" className="w-56 shrink-0">
        <ul className="flex flex-col gap-1 rounded-lg border border-limestone-200 bg-white p-2">
          {ehrDataTabs.map(({ path, name }) => {
            const isCurrent = currentTab === path;
            return (
              <li key={path}>
                <Link
                  to={path}
                  state={state}
                  aria-current={isCurrent ? "page" : undefined}
                  className={clsx(
                    "block rounded-md px-3 py-2",
                    isCurrent ? "bg-limestone-100" : "hover:bg-limestone-50",
                  )}
                >
                  <Label size="small" displayType={isCurrent ? "loud" : "normal"}>
                    {name}
                  </Label>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
      <div className="min-w-0 flex-1">
        <Outlet />
      </div>
    </div>
  );
};
